<template>
  <v-dialog v-model="modalStore.isNewUserModalVisible" persistent max-width="500px">
    <v-card>
      <v-card-title v-if="modalStore.newUserModalVerb === 'create'">
        Create A New User
      </v-card-title>

      <v-card-title v-if="modalStore.newUserModalVerb === 'edit'">
        Edit User
      </v-card-title>

      <v-card-text>
        <v-form ref="newUserForm">
          <v-text-field
            v-model="newUser.name"
            label="Name"
            :rules="[value => !!value || 'Name is required']"
            required
          />
          <v-text-field
            v-model="newUser.email"
            label="Email"
            :rules="[value => !!value || 'Email is required']"
            required
          />
          <v-select
            v-model="newUser.subscription_level"
            :items="subscriptionLevels"
            label="Subscription Level"
            :rules="[value => !!value || 'Subscription Level is required']"
            required
          />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="close">Close</v-btn>
        <v-btn color="green darken-1" text @click="submit">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import { useModalStore } from '@/store';
import { usePopupStore } from '@/store';
import { ref, watchEffect } from 'vue';

export default {
  name: 'NewUserModal',
  setup() {
    const modalStore = useModalStore();
    const popupStore = usePopupStore();

    const newUser = ref({
      name: '',
      email: '',
      subscription_level: '',
    });

    const subscriptionLevels = ['free', 'premium', 'admin'];

    // Initialize newUser when the modal becomes visible
    watchEffect(() => {
      if (modalStore.isNewUserModalVisible) {
        newUser.value = {
          name: '',
          email: '',
          subscription_level: '',
          ...modalStore.prefilledUserData, // Merge prefilled data
        };
      }
    });

    return {
      modalStore,
      popupStore,
      newUser,
      subscriptionLevels,
    };
  },
  methods: {
    close() {
      this.modalStore.closeNewUserModal();
    },
    async submit() {
      if (!this.newUser.name || !this.newUser.email || !this.newUser.subscription_level) {
        return;
      }

      if (this.modalStore.newUserModalVerb === 'create') {
        try {
          await axios.post('/api/users/', this.newUser);
          this.popupStore.setMessage('User Created', 'User successfully added!', 'success');
          this.$eventBus.emit('user-updated');
          this.close();
        } catch (error) {
          this.popupStore.setMessage('Error Creating User', error.response?.data?.message || error.message);
        }
      } else if (this.modalStore.newUserModalVerb === 'edit') {
        try {
          await axios.put(`/api/users/${this.newUser.id}`, this.newUser);
          this.popupStore.setMessage('User Edited', 'User successfully updated!', 'success');
          this.$eventBus.emit('user-updated');
          this.close();
        } catch (error) {
          this.popupStore.setMessage('Error Updating User', error.response?.data?.message || error.message);
        }
      }
    },
  },
};
</script>